exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vat-zero-rules[data-v-71e6a64e]{font-size:.72rem;line-height:1.35;color:#5c636a}.vat-zero-rules__title[data-v-71e6a64e]{font-size:.68rem;text-transform:uppercase;letter-spacing:.02em}.vat-zero-rules ul li[data-v-71e6a64e]{margin-bottom:.15rem}.vat-zero-download-wrap[data-v-71e6a64e]{max-width:32rem;margin-left:auto;margin-right:auto}.vat-zero-download-btn[data-v-71e6a64e]{max-width:25rem;min-width:12rem;height:50px;font-weight:600}.vat-zero-convert[data-v-71e6a64e]{max-width:40rem}.vat-zero-merge-list[data-v-71e6a64e]{max-width:36rem}", ""]);

// exports
